import { render, staticRenderFns } from "./OsSurveyStepIntroData.vue?vue&type=template&id=6ecf881e&scoped=true"
import script from "./OsSurveyStepIntroData.vue?vue&type=script&lang=ts"
export * from "./OsSurveyStepIntroData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf881e",
  null
  
)

export default component.exports